/*
时间转换方法
 */
export const formatDate = (time) => {
  var datetime=new Date(time*1000);
  var year=datetime.getFullYear();
  var month=datetime.getMonth()+1;
  var date=datetime.getDate();
  var hour=datetime.getHours();
  var minute=datetime.getMinutes();
  var second=datetime.getSeconds();
  return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
}
//获取某天距离现在的天数
export const getDiffDays = (dateobj) => {
    let timestamp1 = Date.parse(dateobj);   //毫秒
    let timestamp2 = Date.parse(new Date());   //毫秒
    return parseInt((timestamp2 - timestamp1)/86400000);
}



// WEBPACK FOOTER //
// ./src/utils/date.js